/**
Copyright © 2024 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import type { AxiosInstance, AxiosRequestConfig } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { AxiosErrorException } from '@hems/util/src/exception/exception';

type AnnualReportEmailResponse = {
  status: number;
};

export default class DownloadService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** 연간 리포트 파일 다운로드 */
  annualReportFileDownload = async (siteId: string, params: any): Promise<Blob> => {
    return await this.get<Blob>(apiWrapper.managerApi(`/histories/annual-reports/${siteId}/file`), params, {
      headers: {
        Accept: '*/*',
      },
      responseType: 'blob',
    });
  };

  /** 연간 리포트 이메일 전송 */
  annualReportSendEmail = async (
    siteId: string,
    params: any,
    config?: AxiosRequestConfig
  ): Promise<AnnualReportEmailResponse> => {
    const url = apiWrapper.managerApi(`/histories/annual-reports/${siteId}/mail`);
    try {
      const { status } = await this.axios.post<AnnualReportEmailResponse>(url, params, config);

      return { status };
    } catch (e) {
      throw new AxiosErrorException(url, params, e);
    }
  };
}
